// extracted by mini-css-extract-plugin
export var gif = "_by-0";